import React from 'react'
import { Link } from "../../plugins/gatsby-plugin-atollon"
import { Logo, RightArrow } from './icons'

const Footer = (props) => {

  return (
    <footer className={`footer${props.subscribe ? ' footer--subscribe' : ''}`}>
      <div className='footer__top'>
        <nav className='footer__nav'>
          <ul>
            <li><Link to='https://www.realestate.com.au/agency/silo-real-estate-KTOGBQ'target='_blank' rel='noopener noreferrer'>Listings</Link></li>
            <li><Link to='https://www.linkedin.com/company/silogroupau/' target='_blank' rel='noopener noreferrer'>LinkedIn</Link></li>
            <li><Link to='https://www.instagram.com/silogroupau/' target='_blank' rel='noopener noreferrer'>Instagram</Link></li>
          </ul>
        </nav>
        <nav className='footer__nav'>
          <ul>
            <li><Link to='mailto:info@silorealestate.com.au'>info@silorealestate.com.au</Link></li>
            <li><Link to='tel:+61392962118'>03 9296 2118</Link></li>

          </ul>
          <ul>
           <li>459 Toorak Road,</li>
            <li>Toorak VIC 3142 Australia</li>
          </ul>
        </nav>
      </div>
      <div className='footer__bottom'>
        <div className='footer__logo'>
          <Link to='/'>
            <Logo />
          </Link>
        </div>
        <div className='footer__subscribe'>
          <p>Subscribe for updates</p>
          <button onClick={() => props.setSubscribe(true)}>
            <span>Email</span>
            <RightArrow />
          </button>
        </div>
      </div>
    </footer>
  )
}

export default Footer
